module.exports = __webpack_public_path__ + "static/media/bg_main_screen.681afa6d.png";